import { useRef } from 'react';
import { Navigation } from '@/components/Navigation';
import { HeroSection } from '@/components/HeroSection';
import { ProblemSection } from '@/components/ProblemSection';
import { SolutionSection } from '@/components/SolutionSection';
import { WaitlistForm } from '@/components/WaitlistForm';
import { Footer } from '@/components/Footer';

export default function LandingPage() {
  const waitlistRef = useRef(null);
  
  const scrollToWaitlist = () => {
    waitlistRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  
  return (
    <div className="min-h-screen bg-background">
      <Navigation onCTAClick={scrollToWaitlist} />
      <HeroSection onCTAClick={scrollToWaitlist} />
      <ProblemSection />
      <SolutionSection />
      <div ref={waitlistRef}>
        <WaitlistForm />
      </div>
      <Footer />
    </div>
  );
}
